<template>
    <div class="stepper">
        <a
            href="/"
            class="btn-picto btn-picto--white absolute top-20 lg:top-8 left-1/2 -translate-x-1/2 lg:transform-none lg:left-10 z-20 whitespace-nowrap"
        >
            Retour à la page d'accueil
        </a>
        <div class="stepper__container min-h-screen background-gradient relative flex flex-col items-center py-32 lg:py-36 px-4">
            <div ref="dots" class="stepper__dots flex items-start relative mt-6 mb-6 md:mb-0 md:mt-0 md:absolute md:left-1/2 md:transform md:-translate-x-1/2">
                <div
                    v-for="(step, index, key) in steps"
                    :key="key"
                    :class="{
                        'h-px opacity-40': currentStepIndex < index,
                        'h-0.5': currentStepIndex > index,
                        'h-0.75': currentStepIndex === index,
                        'ml-1': index > 0
                    }"
                    class="stepper__dot w-6 bg-white"
                />
            </div>

            <div class="stepper__content flex-grow flex flex-col pt-5 md:pt-0 md:justify-center md:items-center">
                <p v-if="countText" ref="count" class="stepper__count overline text-white text-center mb-2 md:mb-3">
                    {{ getStepperCount(currentStepIndex + 1) }}
                </p>
                <template
                    v-for="(step, index, key) in steps"
                    :key="key"
                >
                    <component
                        v-if="currentStepIndex === index"
                        :is="step.type"
                        :step="step"
                        :choices-index="(savedValues && savedValues[savedValues.length - 1] && savedValues[savedValues.length - 1][0] && savedValues[savedValues.length - 1][0].nextQuestionChoicesIndex !== null) ? savedValues[savedValues.length - 1][0].nextQuestionChoicesIndex : null"
                        :last-step="index === steps.length - 1"
                        @scroll-to-extra="scrollToExtra"
                        @step-done="nextStep"
                        @final-step="finalStep"
                    />
                </template>
            </div>

            <button v-if="currentStepIndex > 0 || initPreviousStepLink" class="btn-arrow p-4 mt-2 mb-4" @click.prevent="goToPreviousStep">
                {{ previousStepText }}
            </button>
        </div>
        <div ref="extra">
            <component
                v-if="steps[currentStepIndex].extra"
                :is="steps[currentStepIndex].extra"
            />
        </div>
    </div>
</template>

<script>
    import SingleChoiceStep from '@/app/components/SingleChoiceStep';
    import ExtraIMC from '@/app/components/ExtraIMC';
    import gsap from '@lahautesociete/gsap';
    import { ScrollToPlugin } from '@lahautesociete/gsap/ScrollToPlugin';
    gsap.registerPlugin(ScrollToPlugin);

    export default {
        props: {
            steps: { type: Array, default: () => {} },
            previousStepText: { type: String, default: '' },
            countText: { type: String, default: null },
            restart: { type: Boolean, default: false },
            initPreviousStepLink: { type: Boolean, default: false }
        },

        components: {
            SingleChoiceStep,
            ExtraIMC,
        },

        data() {
            return {
                currentStepIndex: 0,
                savedValues: []
            }
        },

        watch: {
            currentStepIndex() {
                if (this.currentStepIndex < 0) this.currentStepIndex = 0;
                else if (this.currentStepIndex > this.steps.length - 1) this.currentStepIndex = this.steps.length - 1;
            },

            restart() {
                if (this.restart) {
                    this.currentStepIndex = 0;
                    this.savedValues = [];

                    this.$emit('restart-done');
                }
            }
        },

        methods: {
            // Go to next step
            nextStep(pValue) {
                if (pValue) {
                    this.savedValues.push(pValue);
                }

                if (this.currentStepIndex + 1 <= this.steps.length - 1) {
                    this.currentStepIndex++;
                } else {
                    this.launchFinalStep();
                }
            },

            finalStep(value) {
                if(value) {
                    this.savedValues.push(value);
                }

                this.launchFinalStep();
            },

            goToPreviousStep() {
                if (this.currentStepIndex === 0) {
                    this.$emit('previous-step');
                } else {
                    this.currentStepIndex--;

                    if (this.savedValues.length > 0) {
                        this.savedValues.splice(this.savedValues.length - 1, 1);
                    }
                }
            },

            launchFinalStep() {
                this.$emit('stepper-done', this.savedValues);
            },

            getStepperCount(pIndex) {
                return this.countText.replace('${n}', pIndex + '/' + this.steps.length)
            },

            scrollToExtra() {
                gsap.to(window, {
                    scrollTo: this.$refs.extra.offsetTop,
                    duration: 0.5,
                    ease: 'power3.out'
                })
            }
        }
    }
</script>

<style lang="scss">
    .stepper {
        &__dots {
            @screen md {
                bottom: 4.625rem;
            }
        }

        &__dot {
            transition: all 0.3s ease-out;
        }
    }
</style>
